<div class="tw-p-6 tw-card tw-h-full tw-flex tw-flex-col tw-relative tw-transition tw-duration-300"
(mouseenter)="destacado = true"
(mouseleave)="destacado = false"
     [ngClass]="destacado ? 'tw-bg-[#F67011]' : 'tw-bg-white'">
  <img [src]="destacado ? 'assets/iconBlack.svg' : 'assets/icon.svg'"
       alt="icon"
       class="tw-w-8 sm:tw-w-8 md:tw-w-8 tw-transition tw-duration-300 lg:tw-w-10 tw-absolute tw-right-4 tw-top-[10px]"/>

  <div class="tw-px-4 tw-flex-1 tw-flex tw-flex-col">
    <!-- Título limitado a 2 líneas -->
    <h3 
  class="tw-text-xl tw-transition tw-duration-300 md:tw-text-2xl lg:tw-text-3xl tw-font-bold tw-text-pretty tw-leading-tight tw-min-h-[2.5em] tw-flex tw-flex-col tw-justify-center"
  [ngClass]="destacado ? 'tw-text-black' : 'tw-text-[#F67011]'"
>
  <span>{{ title }}</span>
  <span [ngClass]="destacado ? 'tw-text-white' : 'tw-text-black'">{{ subTitle }}</span>
</h3>

    <!-- Texto -->
    <p class="tw-mt-2 tw-text-sm tw-transition tw-duration-300 md:tw-text-lg tw-text-justify"
       [ngClass]="['tw-text-gray-700', destacado ? 'tw-text-white' : 'tw-text-black']">
      {{ text }}
    </p>

    <!-- Espacio para el botón -->
    <div class="tw-h-24"></div>

    <!-- Botón -->
    <div class="tw-absolute tw-bottom-4 tw-transition tw-duration-300 tw-left-0 tw-right-0 tw-flex tw-justify-center">
      <button
       onclick="window.open('https://api.whatsapp.com/send/?phone=582813169200&text=Hola%2C+estoy+interesado+en+el+servicio+de+internet+por+fibra+%C3%B3ptica&type=phone_number&app_absent=0', '_blank')"
      class="tw-px-5 md:tw-px-6 tw-py-2 tw-rounded-md tw-font-semibold tw-space-x-2 tw-text-sm md:tw-text-base"
              [ngClass]="destacado ? 'tw-text-white' : 'tw-text-[#F67011]'">
        <i class="bi bi-arrow-right tw-text-black tw-text-lg md:tw-text-xl"></i>
        <span>{{ buttonText }}</span>
      </button>
    </div>
  </div>
</div>